export default __webpack_public_path__ + "static/media/marauders-map-v4-gallery-08.53db5972.jpg";